import React, { useState, useEffect } from 'react'
import axios from "axios";

import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { MdCancel } from "react-icons/md";
import DocumentList from "app/shared/components/ReusableComponents/Carousel/DocumentList/documentList";
import CommonDropdown from "app/shared/components/ReportModal/CommonDropdown";
import AlertMessage from "app/shared/components/Popups/AlertMessage";
import FetchCategoryList from "app/views/Admin/DocumentCategory/Services/fetchCategoryList";
import LoadingImage from "app/shared/components/Loader/LoadingImage";

import Url from "app/shared/constants/Url";


function DocumentComponent({ t, editFlag, id, module }) {

    const [showModal, setShowModal] = useState(false);
    const [documentLists, setDocumentLists] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [categoryList, setCategoryList] = useState(false);

    const [formData, setFormData] = useState({
        selectedCategoryId: '',
        safetyImages: [],
        name: '',
        description: '',
        maxFilesAttachLimit: 5,
    });

    useEffect(() => {
        documentList();
        _fetchCategoryList();
    }, [id])

    const handleInputClick = () => {
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const documentList = async () => {
        const requestData = {
            module: module,
            id: id
        };

        import("app/shared/utility/UtilFunction").then((utilFunction) => {
            let responseObj = utilFunction.sharedAxiosGETAPISpring(
                Url.documentCategory.getAttachments,
                requestData
            );

            responseObj
                .then(async (response) => {
                    if (response.data.status == 200) {
                        setDocumentLists(response.data.data);
                    } else if (response.data.status == 401) {
                        AlertMessage({ message: response.data.msg, type: "error" });
                    }
                });
        })
    };


    const _fetchCategoryList = async () => {
        try {
            const data = await FetchCategoryList({
                page: -1,
                search: "",
                module: module
            });
            setCategoryList(data.data?.map(({ id, name }) => ({ id, name })));
        } catch (error) {
            console.error("Failed to fetch category", error);
        } finally {
        }
    };

    const _saveDocument = async () => {
        setDataLoading(true);
        const form = new FormData();
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("springToken");

        form.append("auth_key", token);
        form.append("user_id", userId);
        form.append("documentDescription", formData.description);
        form.append("reportedId", id);
        form.append("documentName", formData.name);
        // form.append("file", formData.safetyImages[0]);

        formData.safetyImages.forEach((file, index) => {
            form.append("file", file);
        });

        form.append("documentCategoryId", formData.selectedCategoryId);
        form.append("module", module);

        var ContentType = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              auth_key: token,
              user_id: userId,
            }
          };

        await axios
            .post(Url.documentCategory.addAttachment, form, ContentType)
            .then(async (response) => {
                setFormData({
                    selectedCategoryId: '',
                    safetyImages: [],
                    name: '',
                    description: '',
                    maxFilesAttachLimit: 5,
                });
                if (response.data.status === 200) {
                    AlertMessage({
                        message: t('documentSavedSuccessfully'),
                        type: "success",
                    });
                    setDataLoading(false);
                    documentList();
                    handleCloseModal();
                } else {
                    setDataLoading(false);
                    AlertMessage({
                        message: t('errorInAddingTryAgain'),
                        type: "error",
                    });
                }
            })
            .catch((error) => {
                setDataLoading(false);
                AlertMessage({
                    message: t('errorInAddingTryAgain'),
                    type: "error",
                });
            });
    };

    const handleDelete = async (id) => {
        setDataLoading(true);
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("springToken");
        try {
            const url = `${Url.documentCategory.deleteAttachment}`;

            const requestParams = {
                attachmentId: id,
                user_id: userId,
                auth_key: token
            }

            const response = await axios.delete(url, {
                params: requestParams,
                // headers: {
                //   "Content-Type": "application/json"
                // }
            });

            setDataLoading(false);

            if (response.data.status === 200) {
                AlertMessage({
                    message: "Document deleted successfully",
                    type: "success",
                });
                documentList();
            } else {
                AlertMessage({
                    message: "Error Deleting Document, please try again",
                    type: "error",
                });
            }
        } catch (error) {
            setDataLoading(false);
            AlertMessage({
                message: "An error occurred, please try again later",
                type: "error",
            });
            console.error("Error deleting Document", error);
        }
    };


    const _handleChange = async (item = null, type = "name") => {
        switch (type) {
            case "category":
                setFormData({ ...formData, selectedCategoryId: item })
                break;
            case "name":
                setFormData({ ...formData, name: item });
                break;
            case "description":
                setFormData({ ...formData, description: item });
                break;
            default:
                break;
        }
    }

    const _handleSafetyThoughtImages = async (event) => {
        const fileEvent = Array.from(event.target.files);
        event.target.value = "";

        // console.log(fileEvent);
        // const lowStorage = this.checkLowStorage();
        // await this.setState({ isStorageCheckingInProgress: true, });

        // lowStorage
        //   .then(async (response) => {
        //     const { status, msg } = response.data;

        //     if (status == 200) {
        var joined = formData.safetyImages.concat(fileEvent);
        if (joined.length <= formData.maxFilesAttachLimit) {
            await setFormData(prevState => ({
                ...prevState,
                safetyImages: joined,
                fileLimitMsg: false
            }));
        } else {
            await setFormData(prevState => ({
                ...prevState,
                fileLimitMsg: true
            }));

        }
        //     }

        // await setFormData({
        //   lowStorageStatus: status,
        //   lowStorageMessage: msg,
        //   showLowStoragePopup: status == 200 ? false : true,
        // });
        // })
        // .catch((error) => {
        //   console.log(error);
        // })
        // .finally(async () => await this.setState({ isStorageCheckingInProgress: false, }))
    };


    const CrossRed = () => <MdCancel style={{ color: "red", fontSize: "20px" }} />;

    const _removePreviewFile = async (key) => {
        await setFormData((prevState) => {
            const updatedSafetyImages = [...prevState.safetyImages];
            updatedSafetyImages.splice(key, 1);

            return {
                ...prevState,
                safetyImages: updatedSafetyImages,
                fileLimitMsg: updatedSafetyImages.length <= prevState.maxFilesAttachLimit ? false : prevState.fileLimitMsg,
            };
        });
    };

    const _dynamicFileTypeShow = (fileObj) => {
        const type = fileObj.type.split("/");

        if (type[0] === "image") {
            return (
                <img
                    src={URL.createObjectURL(fileObj)}
                    alt=""
                    style={{ width: "150px", height: "150px" }}
                />
            );
        } else if (type[0] === "video") {
            return (
                <video width="200" height="100" controls>
                    <source src={URL.createObjectURL(fileObj)} type="video/mp4" />
                </video>
            );
        } else if (
            fileObj.type === "application/pdf" ||
            fileObj.type === "application/msword" ||
            fileObj.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || // .docx
            fileObj.type === "application/vnd.ms-excel" || // .xls
            fileObj.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || // .xlsx
            fileObj.type === "application/vnd.ms-excel.sheet.macroEnabled.12" || // .xlsm
            fileObj.type === "application/vnd.ms-excel.template.macroEnabled.12" || // .xltm
            fileObj.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.template" || // .xltx
            fileObj.type === "application/vnd.ms-excel.addin.macroEnabled.12" || // .xlam
            fileObj.type === "text/csv" || // .xltm 
            fileObj.type === "application/vnd.ms-powerpoint" ||                       // .ppt
            fileObj.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        ) {
            return (
                <div
                    style={{
                        width: "120px",
                        height: "150px",
                        backgroundColor: "#f1f1f1",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px",
                        textAlign: "center",
                        fontSize: "10px",
                        fontWeight: "bold",
                        overflow: "hidden",
                        wordBreak: "break-word",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                    title={fileObj.name}
                >
                    {fileObj.name}
                </div>
            );
        }

        return null;
    };

    return (
        <>
            <div
                className="loader"
                style={{ display: dataLoading ? "block" : "none" }}
            >
                <LoadingImage />
            </div>

            <div>

            <div className="row">
                <div className="col-12 col-md-5 col-lg-5">
                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-2">
                        {t('document')}
                    </p>
                </div>
                {editFlag == 1 &&
                    <div className="col-12 col-md-7 col-lg-7 mt-1 d-flex justify-content-end">
                        {/* Input Container - Takes remaining space */}
                        {/* <div className="search-container me-2 flex-grow-1">
                <input
                  type="text"
                  className="form-control w-100 mt-2"
                  placeholder="Search"
                />
              </div> */}

                        {/* Button - Fixed width */}
                        <button
                            className="clide-v2-btn-template clide-v2-primary my-1 mb-1 px-3 justify-content-end"
                            style={{ width: "140px", marginTop: "-10px" }}
                            onClick={handleInputClick}
                        >
                            <span className="clide-v2-white-color">{t('addDocument')}</span>
                        </button>
                    </div>
                }
            </div>

            <div className="row mt-3">
                <DocumentList documentLists={documentLists} editFlag={editFlag} handleDelete={handleDelete} />
            </div>
            </div>
            <Modal size="lg" centered show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex mb-2 gap-2">
                        <CommonDropdown
                            title={t('Document Category')}
                            optionList={categoryList}
                            onChangeHandle={(event) => _handleChange(event, "category")}
                            isRequired
                            value={formData.selectedCategoryId}
                        // hasError={this.state.hazardError}
                        />
                        {/* {!!this.state.hazardError && (
                              <p className="inputErrorMsg">{requiredMessage}</p>
                            )} */}

                    </div>
                    <div className="slds-form-element__control mb-3">
                        <label className="slds-form-element__label">
                            {t('Name')}
                        </label>
                        <input
                            className={`slds-input`}
                            value={formData.name}
                            onChange={(event) =>
                                _handleChange(
                                    event.target.value,
                                    "name"
                                )
                            }
                            placeholder={`Name`}
                        />

                        {/* <ErrorBlock
              message={t('enterAtLeastOneIncidentPerosonName')}
            /> */}

                        {/* <img src={require("assets/sls-icons/V2. New Development/ADD2.svg")} className=" ml-2 cursor-pointer svg-icons" onClick={this._addPersonName} /> */}
                    </div>
                    <div className="mb-3 ">
                        <div className="slds-form-element__control">
                            <label className="slds-form-element__label">
                                {t('Description')}
                            </label>
                            <textarea
                                className="slds-textarea"
                                onChange={(event) =>
                                    _handleChange(event.target.value, "description")
                                }
                                value={formData.description}
                                placeholder={"Please enter your observation"}
                            ></textarea>
                        </div>
                    </div>

                    <div id="dropBox">
                        <form className="imgUploader">
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.6668 21.333V10.4663L11.2002 13.933L9.3335 11.9997L16.0002 5.33301L22.6668 11.9997L20.8002 13.933L17.3335 10.4663V21.333H14.6668ZM8.00016 26.6663C7.26683 26.6663 6.63927 26.4055 6.1175 25.8837C5.59572 25.3619 5.33438 24.7339 5.3335 23.9997V19.9997H8.00016V23.9997H24.0002V19.9997H26.6668V23.9997C26.6668 24.733 26.4059 25.361 25.8842 25.8837C25.3624 26.4063 24.7344 26.6672 24.0002 26.6663H8.00016Z"
                                    fill="#F56620"
                                />
                            </svg>

                            <input
                                type="file"
                                id="imgUpload"
                                multiple
                                accept="image/*,video/*,.ppt,.pptx,.odp,.mp4,.mp3"
                                onChange={_handleSafetyThoughtImages}
                            // disabled={state?.isStorageCheckingInProgress}
                            />
                            <label className="py-5 clide-v2-primary-color" for="imgUpload">
                                {/* t('dropFilesHereOrClickToUpload') */} Select Drag and Drop Image
                            </label>
                        </form>
                        <div>
                            <div class="d-flex justify-content-around flex-wrap">
                                {formData.safetyImages?.map((data, index) => (
                                    <div key={index}>
                                        <div class="text-end">
                                            <button
                                                className="clide-v2-icon-btn"
                                                onClick={() =>
                                                    _removePreviewFile(index)
                                                }
                                            >
                                                <CrossRed />
                                            </button>
                                        </div>
                                        {_dynamicFileTypeShow(data)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* {state.fileLimitMsg && (
            <div className="inputErrorMsg">
              {`${t('maxLimitOfAttachFiles')} ${state.maxFilesAttachLimit}`}
            </div>
          )} */}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button
                        className="clide-v2-primary clide-v2-white-color"
                        variant=""
                        onClick={() =>
                            _saveDocument()
                        }
                    // disabled={state?.isStorageCheckingInProgress}
                    >
                        {t('upload')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DocumentComponent